<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {imLogin} from "@/utils/timUtils";

export default {
  components: {},
  created() {
    this.setIcp()
    setTimeout(() => {
      imLogin(this.bindUuid, this.userSig)
    }, 1000)
  },
  methods: {
    ...mapActions("web", ["setWebIcp", "setTitle"]),
    setIcp() {
      // 遍历webObj数组
      this.webObj.forEach((e) => {
        // 先判断是否是开发环境
        if (process.env.VUE_APP_WEB_URL) {
          // 判断process.env.VUE_APP_WEB_URL是否包含e.webUrl
          if (process.env.VUE_APP_WEB_URL.indexOf(e.webUrl) >= 0) {
            // 调用setWebIcp方法设置webIcp
            this.setWebIcp(e)
            // 返回
            return;
          }
        }
        // 判断window.location.origin是否包含e.webUrl
        if (window.location.origin.indexOf(e.webUrl) >= 0) {
          // 调用setWebIcp方法设置webIcp
          this.setWebIcp(e)
        }
      });
    },
  },
  computed: {
    ...mapState("web", ["webObj"]),
    ...mapState("user", ["userSig", "bindUuid"]),
  },
};
</script>
<style>
.el-button--primary {
  background: #009ef7;
}

.el-dialog {
  border-radius: 0.92rem !important;
}
</style>
